import script from "./PrintFormSuratPernyataanCalonPJO.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintFormSuratPernyataanCalonPJO.vue?vue&type=script&setup=true&lang=js"

import "./PrintFormSuratPernyataanCalonPJO.vue?vue&type=style&index=0&id=0b53da68&lang=css"

const __exports__ = script;

export default __exports__